import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './timeSlotChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Component({
  standalone: false,
  template: templateString
})
export class TimeSlotChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();

    public originalTimeSlots: any;
    public timeSlots: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) {
        this.renderer.addClass(document.body, 'md-skin');
        this.renderer.addClass(document.body, 'landing-page');
        this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("time_slots/update_order", { time_slot_ids: this.timeSlots.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
        });
    }

    cancel() {
        this.bsModalRef.hide();
    }

    formatTime(value) {
        if (!value) {
            return "";
        }

        var matches = value.toString().match(/(\d{2}):(\d{2})/);
        return matches && value.toString().indexOf("T") == -1 ? matches[1] + ":" + matches[2] : moment(value).format("HH:mm");
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.timeSlots, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.timeSlots = JSON.parse(JSON.stringify(this.originalTimeSlots));
    }
}
